
import { useState, useEffect } from 'react';

export function useFavicon(websiteUrl: string) {
  const [favicon, setFavicon] = useState<string | null>(null);
  
  useEffect(() => {
    if (websiteUrl) {
      try {
        const url = new URL(websiteUrl);
        
        // Try Google's favicon service first as it's most reliable
        const googleFaviconUrl = `https://www.google.com/s2/favicons?domain=${url.hostname}&sz=64`;
        
        // Create image element to test if favicon loads
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          setFavicon(googleFaviconUrl);
        };
        img.onerror = () => {
          // If Google's service fails, try direct favicon
          const directFaviconUrl = `${url.protocol}//${url.hostname}/favicon.ico`;
          setFavicon(directFaviconUrl);
        };
        img.src = googleFaviconUrl;
      } catch (error) {
        console.error("Error fetching favicon:", error);
        setFavicon(null);
      }
    }
  }, [websiteUrl]);

  return favicon;
}
